export default "__VITE_ASSET__D0Bz0d4R__"